import React, {
  useState,
  forwardRef,
  useImperativeHandle,
  useMemo,
  useRef
} from "react";
import {
  Drawer,
  Button,
  notification,Timeline,
} from "antd";
import { useSelector} from "react-redux";
import documentManagementAPI from '../../../restAPI/DocumentManagement';
const Context = React.createContext({
  name: "Default",
});
const StepForm = forwardRef((props, ref) => {
  const [visible, setVisible] = useState(false); // Track drawer visibility
  const { token } = useSelector((state) => state.auth);
  const notificationShown = useRef(false); // fot notification
  const [statusTrail, setStatusTrail]= useState([]); //keep status trail details


  // Expose methods to the parent component
  useImperativeHandle(ref, () => ({
    openDrawer: (record) => {
      setVisible(true); // Open drawer
      getStatusTrailData(token ,record);
    },
    closeDrawer: () => {
      setVisible(false); // Close drawer
    },
  }));
  const [api, contextHolder] = notification.useNotification();
  const openNotificationWithIcon = (type, message, description, placement) => {
    api[type]({
      message: message,
      description: description,
      placement
  });
  notificationShown.current = true;
      setTimeout(() => {
        notificationShown.current = false;
      }, 5000);
  };
  const contextValue = useMemo(
    () => ({
      name: "Ant Design",
    }),
    []
  );
//---------------------------------------------------------------------------API calls------------------------------------------------------------------------
  const getStatusTrailData = async (token ,record) =>{
    const formData = new FormData();

    formData.append("MOGU_UUID", record?.documentMoguID);
    formData.append("TPS_Id", record?.tPS_Id !== undefined ? record?.tPS_Id :"");

    await documentManagementAPI.getStatusTrailData(
          token,
          localStorage.getItem("groupId"), 
          localStorage.getItem("companyId"),
          formData
        )
        .then((response) => {
          console.log('response status Trail response',response.statusTrail)
          const rows = [];
          response.statusTrail.map((rowValue) =>  {
            rows.push({ 
              status: rowValue.status, 
              reason:rowValue.reason,
              timestamp: rowValue.timestamp,
              changedBy:rowValue?.changedBy
            });

        });
        setStatusTrail(rows);
      })
      .catch((err) => {
        console.log('err',err)
        if (err.response) {
          openNotificationWithIcon(
            "error",
            "Retrieve Status Trail",
            `${err.response.data.message}`,
            "bottomLeft"
          );
        } else {
          console.log('err else',err)
          openNotificationWithIcon(
            "error",
            "Retrieve Status Trail",
            `${err.message}`,
            "bottomLeft"
          );
        }
      });
  }
//---------------------------------------------------------------------------End of API calls--------------------------------------------------------------

const statusColors = {
  uploaded:'#008080',
  pending: '#ffff00',
  extracted: '#FDC483',
  'failed-submittable':'#FCA746',
  submitted:'#1890ff',
  success: '#52c41a',
  failed:'#ff0000',
  deleted: '#888',
  canceled:'#800080',
  duplicate: '#ff69b4'
};

  const TimelineComponent = ({ statusTrail }) => (
    <Timeline
      items={statusTrail.map((item) => ({
        dot: (
          <div
            style={{
              width: '20px',
              height: '20px',
              backgroundColor: statusColors[item.status] || '#888',
              borderRadius: '50%',
            }}
          />
        ),
        children: (
          <div style={{ display: 'flex', alignItems: 'center', marginTop: '15px' }}>
            <div>
              <div style={{ fontSize: '16px', marginBottom: '4px' }}>
                <strong>{item.status.charAt(0).toUpperCase() + item.status.slice(1)}</strong>
              </div>
              <div style={{ fontSize: '14px', color: '#666' }}>
                <div>{new Date(item.timestamp).toLocaleString()}</div>
                <div>{item.changedBy}</div>
                <div style={{ marginTop: '8px', color: '#888' }}>
                  {item.reason}
                </div>
              </div>
            </div>
          </div>
        ),
      }))}
    />
  );

  return (
    <Context.Provider value={contextValue}>
      {contextHolder}
      <Drawer
        open ={visible}
        onClose={() => setVisible(false)}
        title={
          <div justify="space-between" align="left">
            <span style={{ position: 'relative', top: '5px' }}>Status Trail</span>
          </div>
        }
        width={700}
        footer={
          <div style={{ textAlign: "right" }}>
            <Button style={{ marginRight: 8 }} size="large" onClick={()=>setVisible(false)}>
              Exit
            </Button>


          </div>
        }
      >
       <div style={{ padding: '20px', }}>
        <TimelineComponent statusTrail={statusTrail} /> 
    </div>
      </Drawer>
    </Context.Provider>
  );
});


export default StepForm;
